import { useToast } from '@jaymathew/ui-shared/contexts/ToastContext'
import { useInfiniteQuery } from '@tanstack/react-query'
import getCompaniesQueryOptions, { getCompaniesOptions } from 'queryOptions/getCompanies'
import { AllowedOverrides } from 'queryOptions/queryOptionsUtils.types'


interface UseGetEventsParams {
	params: Omit<getCompaniesOptions, 'lastDocument'>
	overrides?: AllowedOverrides
}

export const useGetCompanies = ({
	params,
	overrides,
}: UseGetEventsParams) => {
	const { triggerToast } = useToast()

	const queryResult = useInfiniteQuery(
		getCompaniesQueryOptions(params, overrides),
	)

	const companies = queryResult.data?.pages.flatMap((page) => page.payload) || []

	if (queryResult.error) {
		triggerToast(`Error fetching companies: ${queryResult.error.message}`, 'error')
	}

	return {
		...queryResult,
		companies,
	}
}
